import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import Navbar from './Navbar/Navbar.js'
import Messi from './Jugadores/Messi/Messi.js'
import Ronaldo from './Jugadores/Ronaldo/Ronaldo.js'
import Maradona from './Jugadores/Maradona/Maradona.js'
import Pele from './Jugadores/Pele/Pele.js'
import Home from './Home.js'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Jugadores/Messi" element={<Messi />} />
        <Route path="/Jugadores/Ronaldo" element={<Ronaldo />} />
        <Route path="/Jugadores/Maradona" element={<Maradona />} />
        <Route path="/Jugadores/Pele" element={<Pele />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
reportWebVitals();
